import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getIsNewDeal = createSelector(
  (state: Store) => state.dealManagement.isNewDeal,
  (isNewDeal) => isNewDeal,
);
